// 推文相关API接口
import request from "@/utils/server";
/**
 * 发布推文接口
 * @param {Object} data - 发布推文的参数
 * @param {Number} data.type - 0-仅发布 1-发布并推送到微信
 * @param {String} data.appId - 发布方式
 * @returns {Promise} 返回axios请求的Promise对象
 */
export function publishArticleAPI(data) {
  return request({
    url: "/wxz/tw/article/issue/article",
    method: "post",
    data,
  });
}

// 获取推文列表接口
export function getTweetListAPI(data) {
  return request({
    url: "/tweet/json/list",
    method: "get",
    params: data,
  });
}

// 获取AI智能写作结果接口
export function getAiWriteResultAPI(data) {
  return request({
    url: "/AI/qwen/chat",
    method: "post",
    data,
  });
}
